const initialState = {
  selectedBot: "",
};

export default (state = initialState, action) => {
  return state;
};
